import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom'
import { Box, Typography, Button, Paper } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

import { logger } from '@/lib/logger'
import { NotFoundPage } from './NotFoundPage'
import { resolveRouteErrorContent } from './routeErrorBoundary.helpers'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  if (isRouteErrorResponse(error) && error.status === 404) {
    logger.error('Route error response', {
      status: error.status,
      statusText: error.statusText,
      data: error.data,
    })
    return <NotFoundPage homeTo="/" />
  }

  const { title, description } = resolveRouteErrorContent(error)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 480,
          p: 4,
          textAlign: 'center',
        }}
      >
        <ErrorOutlineIcon
          sx={{ fontSize: 64, color: 'error.main', mb: 2 }}
        />
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>
        {import.meta.env.DEV && error instanceof Error && error.stack ? (
          <Typography
            component="pre"
            variant="caption"
            sx={{
              mb: 3,
              maxWidth: '100%',
              overflow: 'auto',
              textAlign: 'left',
              whiteSpace: 'pre-wrap',
              color: 'text.secondary',
              bgcolor: 'action.hover',
              p: 2,
              borderRadius: 1,
            }}
          >
            {error.stack}
          </Typography>
        ) : null}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button variant="contained" onClick={() => navigate('/')}>
            Go to dashboard
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
